import React, { useState, useEffect } from 'react';

const ERPGuide = () => {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      img: "/assets/Login/Guide/erp_app_enter.png",
      desc: "ERP APP을 실행합니다.",
      point: { top: '53%', right: '83%' } // 각 스텝별 강조 위치 조절 가능
    },
    {
      img: "/assets/Login/Guide/2fa_enter.png",
      desc: "화면 상단 2FA 아이콘을 누릅니다.",
      point: { top: '20%', right: '15%' }
    },
    {
      img: "/assets/Login/Guide/2fa_key.png",
      desc: "2FA 인증번호를 확인후 입력합니다.",
      point: { top: '36%', right: '71%' }
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % steps.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [steps.length]);

  return (
    <div className="w-full max-w-md mx-auto">
      {/* 이미지 영역 */}
      <div className="relative w-full overflow-hidden rounded border border-gray-100 shadow-sm bg-gray-50">
        <div className="relative aspect-video w-full bg-white">
          {steps.map((step, index) => (
            <img
              key={index}
              src={step.img}
              alt={`Step ${index + 1}`}
              className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ${
                index === currentStep ? 'opacity-100' : 'opacity-0'
              }`}
            />
          ))}
        </div>

        {/* 애니메이션 오버레이 (클릭 파동 효과만 남김) */}
        <div className="absolute inset-0 pointer-events-none">
          {steps.map((step, index) => (
            <div
              key={index}
              style={{ top: step.point.top, right: step.point.right }}
              className={`absolute transition-opacity duration-700 ${
                index === currentStep ? 'opacity-100' : 'opacity-0'
              }`}
            >
              {/* 중앙 점 */}
              <div className="w-2 h-2 bg-blue-500 rounded-full" />
              {/* 퍼지는 파동 효과 */}
              <div className="absolute -top-1 -left-1 w-4 h-4 bg-blue-400 rounded-full animate-ping opacity-75" />
            </div>
          ))}
        </div>

        {/* 스텝 인디케이터 */}
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5">
          {steps.map((_, i) => (
            <div 
              key={i} 
              className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                i === currentStep ? 'bg-blue-500 w-3' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>

      {/* 가이드 문구 영역 */}
      <div className="min-h-[50px] flex items-center justify-center">
        <p className="text-[11px] mt-2 leading-relaxed text-gray-600 whitespace-pre-line text-center">
          {steps[currentStep].desc}
        </p>
      </div>
    </div>
  );
};

export default ERPGuide;